import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Scissors, Droplets, UserCheck } from 'lucide-react';
const steps = [{
  icon: Coffee,
  title: 'La Llegada',
  desc: 'Llegás después del trabajo. No hay fila. Tu turno estaba reservado previo al fin de semana. Te reciben y te preguntan qué querés tomar: ¿café, cerveza o un trago de la barra Rotterdam?'
}, {
  icon: Scissors,
  title: 'El Proceso',
  desc: 'Te sentás en el sillón. El ambiente tiene la energía justa. El barbero arranca con el corte. Old school. Con precisión. Con presencia.'
}, {
  icon: Droplets,
  title: 'El Ritual',
  desc: 'Llega la parte que cambia todo: la toalla caliente. El vapor. La navaja sobre la piel. El arreglo de barba que deja los bordes como si fueran dibujados.'
}, {
  icon: UserCheck,
  title: 'El Resultado',
  desc: 'Cuando terminás, no te vas rápido. Terminás tu trago. Te mirás en el espejo. Y la persona que te devuelve la mirada se ve exactamente como vos querías verte.'
}];
export function Experience() {
  return <section id="experience" className="pt-10 pb-20 px-6 bg-rotterdam-black relative" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-58">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-59">
            ¿Cómo será tu experiencia en Rotterdam?
          </h2>
          <p className="text-rotterdam-gray text-lg max-w-2xl mx-auto" data-id="element-60">
            Imaginá esto — un jueves a las 18:00.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-61">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-rotterdam-border z-0" data-id="element-62" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative" data-id="element-63">
              <div className="border-2 border-rotterdam-gold pearl-border bg-rotterdam-black p-6 flex flex-col items-center text-center h-full hover:bg-[#6BB8D4]/10 transition-colors duration-300" data-id="element-64">
                <div className="w-16 h-16 rounded-full border-2 border-rotterdam-gold pearl-border flex items-center justify-center mb-5" data-id="element-65">
                  <step.icon className="w-7 h-7 text-rotterdam-gold pearl-icon" data-id="element-66" />
                </div>
                <h3 className="text-xl font-serif font-semibold mb-3" data-id="element-67">
                  {step.title}
                </h3>
                <p className="text-rotterdam-cream/80 leading-relaxed" data-id="element-68">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="mt-20 text-center" data-id="element-69">
          <p className="text-xl md:text-2xl font-serif italic text-rotterdam-gold pearl-text whitespace-nowrap" data-id="element-70">
            Más que un corte, un ritual.
          </p>
        </motion.div>
      </div>
    </section>;
}